// This import loads the firebase namespace along with all its type information.
import CuratedMediaList from './curated-media-list-model'

export async function load_curatedMediaLists(): Promise<CuratedMediaList[]> {
  throw 'Not implemented'
}

export async function delete_curatedMediaList(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_curatedMediaList(): Promise<CuratedMediaList> {
  throw 'Not implemented'
}
